// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "editor-vendors" + "." + "649e3551" + ".chunk.css";
};